import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-overview-page',
  templateUrl: './insurance-overview-page.component.html',
  styleUrls: ['./insurance-overview-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsuranceOverviewPageComponent {

}
